export var ModuleType;
(function (ModuleType) {
    ModuleType["AuditLogs"] = "audit-logs";
    ModuleType["Auth"] = "auth";
    ModuleType["Authorize"] = "authorize";
    ModuleType["Computations"] = "computations";
    ModuleType["Connections"] = "connections";
    ModuleType["Dashboards"] = "dashboards";
    ModuleType["Data"] = "data";
    ModuleType["Export"] = "export";
    ModuleType["Pipes"] = "pipes";
    ModuleType["Recommend"] = "recommend";
    ModuleType["Results"] = "results";
    ModuleType["ReusableLogics"] = "reusable-logics";
    ModuleType["Schedules"] = "schedules";
    ModuleType["Solutions"] = "solutions";
    ModuleType["Subscriptions"] = "subscriptions";
})(ModuleType || (ModuleType = {}));
//# sourceMappingURL=moduleTypeResources.js.map